/**
* GENERATED BY RPC GEN - LESS MODIFY BY HAND
* topic-service.ts  2023-11-13T18:19:31+08:00
*/
import type { R, RpcService, MethodConfig as M } from 'bt-rpc-base';

import type { MoreTopic, Reply, TopicIdSize, Topic, Room, MoreReply } from './discuss-dto';

const _ = 'Topic/';

export class TopicService {

  constructor(readonly r: RpcService) {}
  // 获取主题总数
  count(d:Room, m?: M): R<number>{
    return this.r.async(_ + 'count', d, m);
  }
  // 展示更多新回复
  listNewReply(d:MoreReply, m?: M): R<Array<Reply>>{
    return this.r.async(_ + 'listNewReply', d, m);
  }
  // 更多老主题
  listOld(d:MoreTopic, m?: M): R<Array<Topic>>{
    return this.r.async(_ + 'listOld', d, m);
  }
  // 展示主题
  show(d:TopicIdSize, m?: M): R<Topic>{
    return this.r.async(_ + 'show', d, m);
  }
}
